export const REQUEST_CATEGORIES = [
    {value: 'report_annulment', text: 'Аннулирование отчётов', icon: 'fas fa-file-excel', description: 'Аннулирование сменных отчётов'},
    {
        value: 'timesheet_submission_extension',
        text: 'Табели',
        icon: 'fas fa-calendar-alt',
        description: 'Продление срока подачи табелей'
    },
    {
        value: 'materials',
        text: 'Снабжение',
        icon: 'fas fa-boxes',
        description: 'Материалы, поставки, закупки'
    },
    {
        value: 'it',
        text: 'ИТ-поддержка',
        icon: 'fas fa-laptop',
        description: 'Компьютеры, доступы, техника'
    },
    {
        value: 'finance',
        text: 'Бухгалтерия',
        icon: 'fas fa-file-invoice-dollar',
        description: 'Оплаты, счета и бухгалтерские документы'
    },
    {
        value: 'fuelCards',
        text: 'Топливные карты',
        icon: 'fas fa-gas-pump',
        description: 'Карты и суточные лимиты топлива'
    },
    {
        value: 'mechanics',
        text: 'Отдел механиков',
        icon: 'fas fa-tools',
        description: 'Техника, механизмы, ремонт и аренда'
    },
    {
        value: 'admin',
        text: 'Административные',
        icon: 'fas fa-building',
        description: 'Оргвопросы и хозяйственные заявки'
    },
    {
        value: 'hr',
        text: 'Кадры',
        icon: 'fas fa-users',
        description: 'Сотрудники и кадровые процессы'
    },
    {
        value: 'other',
        text: 'Прочее',
        icon: 'fas fa-ellipsis-h',
        description: 'Другие обращения'
    }
];

export function normalizeRequestCategory(category) {
    const value = String(category || '').trim();
    return REQUEST_CATEGORIES.some(item => item.value === value) ? value : 'other';
}

export function getRequestCategoryText(category) {
    const value = normalizeRequestCategory(category);
    const option = REQUEST_CATEGORIES.find(item => item.value === value);
    return option ? option.text : value;
}
